import PropTypes from 'prop-types';
import React from 'react';
import AngleDownSVG from '../../../assets/raw-svg/fontawesome/angle-down.svg';
import AngleLeftSVG from '../../../assets/raw-svg/fontawesome/angle-left.svg';
import AngleRightSVG from '../../../assets/raw-svg/fontawesome/angle-right.svg';
import AngleUpSVG from '../../../assets/raw-svg/fontawesome/angle-up.svg';
import ArrowLeftSVG from '../../../assets/raw-svg/fontawesome/long-arrow-left.svg';
import BarsSVG from '../../../assets/raw-svg/fontawesome/bars.svg';
import CaretDownSVG from '../../../assets/raw-svg/fontawesome/caret-down.svg';
import CaretUpSVG from '../../../assets/raw-svg/fontawesome/caret-up.svg';
import CarouselArrowLeftSVG from '../../../assets/raw-svg/fontawesome/carousel-arrow-left.svg';
import CarouselArrowRightSVG from '../../../assets/raw-svg/fontawesome/carousel-arrow-right.svg';
import CheckSVG from '../../../assets/raw-svg/fontawesome/check.svg';
import ChevronDownSVG from '../../../assets/raw-svg/fontawesome/angle-down.svg'; // changed to Angle
import ChevronLeftSVG from '../../../assets/raw-svg/fontawesome/angle-left.svg'; // changed to Angle
import ChevronRightSVG from '../../../assets/raw-svg/fontawesome/angle-right.svg'; // changed to Angle
import ChevronUpSVG from '../../../assets/raw-svg/fontawesome/angle-up.svg'; // changed to Angle
import CommentSVG from '../../../assets/raw-svg/fontawesome/comment.svg';
import CommentsSVG from '../../../assets/raw-svg/comments.svg';
import CommentsOSVG from '../../../assets/raw-svg/fontawesome/comments-o.svg';
import EnvelopeSVG from '../../../assets/raw-svg/fontawesome/envelope-o.svg';
import FacebookSVG from '../../../assets/raw-svg/fontawesome/facebook.svg';
import FlipboardSVG from '../../../assets/raw-svg/fontawesome/flipboard.svg';
import InstagramSVG from '../../../assets/raw-svg/fontawesome/instagram.svg';
import MinusSVG from '../../../assets/raw-svg/fontawesome/minus.svg';
import PinterestSVG from '../../../assets/raw-svg/fontawesome/pinterest-p.svg';
import PlusSVG from '../../../assets/raw-svg/fontawesome/plus.svg';
import RefreshSVG from '../../../assets/raw-svg/fontawesome/refresh.svg';
import SearchSVG from '../../../assets/raw-svg/fontawesome/search.svg';
import SlidersSVG from '../../../assets/raw-svg/fontawesome/sliders.svg';
import SlideshowShopArrowLeftSVG from '../../../assets/raw-svg/fontawesome/slideshow-shop-arrow-left.svg';
import SlideshowShopArrowRightSVG from '../../../assets/raw-svg/fontawesome/slideshow-shop-arrow-right.svg';
import ThSVG from '../../../assets/raw-svg/fontawesome/th.svg';
import TikTokSVG from '../../../assets/raw-svg/fontawesome/tiktok.svg';
import TimesSVG from '../../../assets/raw-svg/fontawesome/times.svg';
import TwitterSVG from '../../../assets/raw-svg/fontawesome/twitter.svg';
import UnevenBarsSVG from '../../../assets/raw-svg/fontawesome/uneven-bars.svg';
import WhatsAppSVG from '../../../assets/raw-svg/fontawesome/whatsapp.svg';
import YouTubePlaySVG from '../../../assets/raw-svg/fontawesome/youtube-play.svg';
import R29NavLogoSVG from '../../../assets/raw-svg/r29-logo-condensed-w.svg';
import VMGSVG from '../../../assets/raw-svg/vice-media-group-logo.svg';
import EmailShoesSVG from '../../../assets/raw-svg/email-shoes.svg';

export const SVGs = {
  'angle-down': AngleDownSVG,
  'angle-left': AngleLeftSVG,
  'angle-right': AngleRightSVG,
  'angle-up': AngleUpSVG,
  'bars': BarsSVG,
  'long-arrow-left': ArrowLeftSVG,
  'caret-down': CaretDownSVG,
  'caret-up': CaretUpSVG,
  'carousel-arrow-left': CarouselArrowLeftSVG,
  'carousel-arrow-right': CarouselArrowRightSVG,
  'check': CheckSVG,
  'chevron-down': ChevronDownSVG,
  'chevron-left': ChevronLeftSVG,
  'chevron-right': ChevronRightSVG,
  'chevron-up': ChevronUpSVG,
  'comment': CommentSVG,
  'comments': CommentsSVG,
  'comments-o': CommentsOSVG,
  'envelope-o': EnvelopeSVG,
  'facebook': FacebookSVG,
  'flipboard': FlipboardSVG,
  'instagram': InstagramSVG,
  'minus': MinusSVG,
  'pinterest-p': PinterestSVG,
  'plus': PlusSVG,
  'refresh': RefreshSVG,
  'search': SearchSVG,
  'sliders': SlidersSVG,
  'slideshow-shop-arrow-left': SlideshowShopArrowLeftSVG,
  'slideshow-shop-arrow-right': SlideshowShopArrowRightSVG,
  'th': ThSVG,
  'tiktok': TikTokSVG,
  'times': TimesSVG,
  'twitter': TwitterSVG,
  'uneven-bars': UnevenBarsSVG,
  'whatsapp': WhatsAppSVG,
  'youtube-play': YouTubePlaySVG,
  'r29-nav-logo': R29NavLogoSVG,
  'vmg': VMGSVG,
  'email-shoes': EmailShoesSVG
};

export const FaIcon = ({ iconName, tagName = 'i', innerHTML = '', className = '', ariaHidden = 'true', title = '' }) => {
  const Tag = tagName;
  return (
    <Tag
      className={`fa fa-${iconName} ${className}`}
      {...(iconName && ariaHidden !== 'false' ? { 'aria-label': `${iconName}` } : {})}
      {...(ariaHidden !== 'false' ? { 'aria-hidden': 'true' } : {})}
      {...(title !== '' ? { title: title } : {})}
      dangerouslySetInnerHTML={{ __html: innerHTML + SVGs[iconName] }}
    />
  );
};

export const FaSVG = ({ iconName }) => SVGs[iconName];

export const AngleDown = () => <FaIcon iconName="angle-down" />;
export const AngleUp = () => <FaIcon iconName="angle-up" />;
export const CaretDown = () => <FaIcon iconName="caret-down" />;
export const CaretUp = () => <FaIcon iconName="caret-up" />;
export const ChevronLeft = () => <FaIcon iconName="angle-left" />;
export const ChevronRight = () => <FaIcon iconName="angle-right" />;
export const Th = () => <FaIcon iconName="th" />;
export const ArrowLeft = () => <FaIcon iconName="long-arrow-left" />;
export const Check = () => <FaIcon iconName="check" />;
export const Minus = () => <FaIcon iconName="minus" />;
export const Plus = () => <FaIcon iconName="plus" />;
export const Times = () => <FaIcon iconName="times" />;
export const Refresh = () => <FaIcon iconName="refresh" />;

FaIcon.propTypes = {
  ariaHidden: PropTypes.string,
  title: PropTypes.string,
  iconName: PropTypes.string.isRequired,
  tagName: PropTypes.string,
  innerHTML: PropTypes.string,
  className: PropTypes.string
};
